<br />
<!-- TODO: Investigate why this <br /> is here — remove if not necessary -->
<!-- TODO: Remove all class names that begin with '!' (e.g., '!k-p-0', '!k-m-0'). 
     We should avoid using override utility classes. Apply specific styles via SCSS instead. -->

<kendo-card class="container grid-width">
  <div>
    <div class="flex k-pl-4 k-pr-4 k-mb-2">
      <h4 class="">Evaluators/Provider</h4>

      <button
        kendoButton
        type="button"
        size="medium"
        rounded="large"
        fillMode="clear"
        class="excel-btn"
        (click)="this.excelexport.save()"
      >
        Export to Excel
      </button>
    </div>

    <div class="loading-container">
      <kendo-loader
        *ngIf="loadSpinner"
        type="converging-spinner"
        size="large"
      ></kendo-loader>
    </div>
    <kendo-grid
      [kendoGridBinding]="gridView"
      [pageSize]="5"
      [pageable]="true"
      [reorderable]="true"
      [resizable]="true"
      [height]="500"
      [sortable]="true"
      [groupable]="true"
      [columnMenu]="{ filter: true }"
      #grid
    >
      <ng-template kendoGridToolbarTemplate>
        <div class="toolbar-container">
          <div>
            <kendo-textbox
              [style.width.px]="298"
              placeholder="Search Provider Name or ID"
              (valueChange)="onAgencyGridFilter($event)"
            >
            </kendo-textbox>
            <ng-template kendoTextBoxPrefixTemplate>
              <div class="k-px-2">
                <kendo-svg-icon
                  [icon]="searchIcon"
                  size="medium"
                  themeColor="primary"
                ></kendo-svg-icon>
              </div>
            </ng-template>
          </div>
        </div>
      </ng-template>
      <kendo-grid-column
        field="fullName"
        title="Evaluator/Provider"
        [width]="300"
        [sticky]="true"
      >
        <ng-template kendoGridCellTemplate let-data>
          <div class="col">
            <h6 class="!k-m-0 k-text-primary">
              {{ data?.firstName }} {{ data?.lastName }}
           
              @if(isNew(data?.lastAccessedDate)){
                <kendo-badge-container class="new-badge-color k-ml-2">
                  <span>
                  NEW
                </span>
                </kendo-badge-container>
              }
            </h6>
            <p class="k-mt-1 k-mb-0">ID:{{ data?.id }}</p>
          </div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="type" title="Type" [width]="220">
        <ng-template kendoGridCellTemplate let-data>
          <div class="col">
            <p class="!k-m-0">
              <kendo-badge-container>
                @if(data?.type === providerTypes.Agency || data?.type === providerTypes.Independent){
                  <span
                    class="k-mr-2 evaluator-badge-color"
                    >Provider</span
                  >
                }
                @if (data?.type === providerTypes.DOE) {
                  <span
                    class="k-mr-2 provider-badge-color"
                    >DOE</span
                  >
                }
              </kendo-badge-container>
            </p>
          </div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="discipline" title="Discipline" [width]="300">
        <ng-template kendoGridCellTemplate let-data>
          <div class="col">
            <p class="!k-m-0">
              {{ data?.discipline }}
            </p>
          </div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="language" title="Language" [width]="300">
        <ng-template kendoGridCellTemplate let-data>
          <div class="col">
            <p class="secondary-color">
              {{ data?.language }}
            </p>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="noOfStudents" title="Max. Students" [width]="180">
        <ng-template kendoGridCellTemplate let-data>
          <div class="col">
            <p class="secondary-color">
              {{ data?.noOfStudents }}
            </p>
          </div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="dbn" title="DBN" [width]="150">
        <ng-template kendoGridCellTemplate let-data>
          <div class="col">
            <p class="secondary-color">
              {{ data?.dbn }}
            </p>
          </div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="status" title="Status" [width]="150">
        <ng-template kendoGridCellTemplate let-data>
          <div class="col">
            <p class="secondary-color">
              {{ data?.status }}
            </p>
          </div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="emailAddress" title="Email Address" [width]="270">
        <ng-template kendoGridCellTemplate let-data>
          <div class="col">
            <p class="secondary-color">
              {{ data?.emailAddress }}
            </p>
          </div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="phoneno" title="Phone Number" [width]="270">
        <ng-template kendoGridCellTemplate let-data>
          <div class="col">
            <p class="secondary-color">
              {{ data?.phoneno }}
            </p>
          </div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column
        field="gridData"
        title="Actions"
        [width]="130"
        [sticky]="true"
      >
        <ng-template kendoGridCellTemplate let-data>
          <div class="col">
            <button
              kendoButton
              [svgIcon]="briefCaseIcon"
              class="k-ml-1 actions-btn-cls k-mr-1"
              (click)="navigateToProviderAgency(data)"
              fillMode="clear"
              aria-label="View provider agency"
            ></button>
            <button
              kendoButton
              [svgIcon]="calendarIcon"
              class="actions-btn-cls"
              fillMode="clear"
              kendoTooltip
              title="View schedule"
              (click)="openScheduleCalendar(data)"
              aria-label="View schedule"
            ></button>
          </div>
        </ng-template>
      </kendo-grid-column>
    </kendo-grid>
  </div>
</kendo-card>

<kendo-excelexport
  [data]="evaluatorExportModel"
  fileName="Evaluator.xlsx"
  #excelexport
>
  <kendo-excelexport-column field="firstName" title="Evaluator/Provider">
  </kendo-excelexport-column>
  <kendo-excelexport-column field="type" title="Type">
  </kendo-excelexport-column>
  <kendo-excelexport-column field="discipline" title="Discipline">
  </kendo-excelexport-column>
  <kendo-excelexport-column field="language" title="Language">
  </kendo-excelexport-column>
  <kendo-excelexport-column field="noOfStudents" title="Max. Students">
  </kendo-excelexport-column>
  <kendo-excelexport-column field="dbn" title="DBN"> </kendo-excelexport-column>
  <kendo-excelexport-column field="status" title="Status">
  </kendo-excelexport-column>
  <kendo-excelexport-column field="emailAddress" title="Email Address">
  </kendo-excelexport-column>
  <kendo-excelexport-column field="phoneno" title="Phone Number">
  </kendo-excelexport-column>
</kendo-excelexport>
